import * as types from "./accountsActionType";

export default function accountsReducer(state = {}, action) {
  switch (action.type) {
    case types.GET_PROVINCES_SUCCESS: {
      let newData = {};
      newData = { ...state, items: [...action.payload.data] };
      return { ...newData };
    }
    case types.GET_BUSINESS_ACCOUNTS_SUCCESS: {
      let newData = {};
      newData = { ...state, items: [...action.payload.data] };
      return { ...newData };
    }
    case types.GET_ACCOUNTS_SUCCESS: {
      let newData = {};
      newData = { ...state, fetched: true, ...action.payload.data };
      return { ...newData };
    }
    case types.UPDATE_ACCOUNTS_FAILURE:
    case types.UPDATE_ACCOUNTS_SUCCESS: {
      let newData = {};
      newData = { ...state, submitting: true, ...action.payload.data };
      return { ...newData };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/accounts/accountsReducer.js